import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input
} from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { Answer } from '../../../model/answer.model';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sources',
  standalone: true,
  imports: [
    CommonModule,
    MatDividerModule,
    MatExpansionModule,
    TranslateModule
  ],
  templateUrl: './sources.component.html',
  styleUrls: ['./sources.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SourcesComponent {
  @Input() chatAnswer?: Answer | null;
  @Input() hideAllContents?: boolean;

  hoveredIndex = 0;

  removeHTTPS(link: string) {
    return link.replace('https://', '');
  }

  preview(_event: MouseEvent | Event, index: number) {
    this.hoveredIndex = index;
  }
}
